import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum IntegrationKey {
  AIMS360 = "aims360",
  APPAREL_MAGIC = "apparel-magic",
  AUTHORIZENET = "authorizenet",
  BLUE_CHERRY = "blue-cherry",
  BLUE_YONDER = "blue-yonder",
  BRIGHTPEARL = "brightpearl",
  CLOUDX = "cloudx",
  COMMENT_SOLD = "comment-sold",
  CREDITSYARD = "creditsyard",
  CUSTOM_RETURN = "custom-return",
  DEPOSCO = "deposco",
  ECWID = "ecwid",
  FLEXPORT = "flexport",
  GLOBALE = "globale",
  IDF_SHIPPING = "idf-shipping",
  INMAR = "inmar",
  KATANA = "katana",
  KLAVIYO = "klaviyo",
  LOOP = "loop",
  LOOPZ = "loopz",
  LUMINOUS = "luminous",
  MASONHUB = "masonhub",
  MINTSOFT = "mintsoft",
  NETSUITE = "netsuite",
  PURPLE_DOT = "purple-dot",
  REFUNDID = "refundid",
  RETURNBEAR = "returnbear",
  RISE_AI = "rise-ai",
  RIVO = "rivo",
  RYDER = "ryder",
  SEKO = "seko",
  SHIPBOB = "shipbob",
  SHIPEDGE = "shipedge",
  SHIPHERO = "shiphero",
  SHIPMONK = "shipmonk",
  TEAMWORK_COMMERCE = "teamwork-commerce",
  TIKTOK_SHOP = "tiktok-shop",
  TRACKSTAR = "trackstar",
}

const integrationStatusSchema = z.object({ isConnected: z.boolean() });

export const getAllIntegrationStatuses = {
  name: "getAllIntegrationStatuses" as const,
  input: z.null(),
  output: z.record(createEnum(IntegrationKey), integrationStatusSchema),
};
